module.exports = __webpack_public_path__ + "img/spade.2f04045a.jpg";